import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const GlobeErrorPage = ()=>{
    const comet1Ref = React.useRef(null);
    const comet2Ref = React.useRef(null);
    const svgRef = React.useRef(null);
    React.useEffect(()=>{
        if (!comet1Ref.current || !comet2Ref.current || !svgRef.current) return;
        const comet1 = comet1Ref.current;
        const comet2 = comet2Ref.current;
        const svg = svgRef.current;
        const comet1Animation = comet1.getAnimations()[0];
        const comet2Animation = comet2.getAnimations()[0];
        let isHovering = false;
        let animationFrameId;
        // Ellipse center and parameters for orbit path
        const centerX = 183;
        const centerY = 150;
        const radiusX = 120;
        const radiusY = 55;
        const calculateAngleFromMouse = (mouseX, mouseY)=>{
            const dx = mouseX - centerX;
            const dy = mouseY - centerY;
            // Adjust for ellipse by scaling y
            const angle = Math.atan2(dy / radiusY, dx / radiusX);
            return angle;
        };
        const angleToOffsetDistance = (angle)=>{
            // Convert angle (0 to 2π) to offset-distance (0 to 100%)
            // Normalize angle to 0-1 range
            let normalizedAngle = (angle + Math.PI) / (2 * Math.PI);
            if (normalizedAngle < 0) normalizedAngle += 1;
            if (normalizedAngle > 1) normalizedAngle -= 1;
            return normalizedAngle;
        };
        const handleMouseMove = (e)=>{
            if (!isHovering) return;
            const rect = svg.getBoundingClientRect();
            const mouseX = e.clientX - rect.left;
            const mouseY = e.clientY - rect.top;
            const angle = calculateAngleFromMouse(mouseX, mouseY);
            const targetDistance = angleToOffsetDistance(angle);
            // Smoothly lerp comets toward target position
            const lerp = (start, end, factor)=>{
                // Handle wrapping around 0/1 boundary
                let diff = end - start;
                if (Math.abs(diff) > 0.5) {
                    if (diff > 0) diff -= 1;
                    else diff += 1;
                }
                let result = start + diff * factor;
                if (result < 0) result += 1;
                if (result > 1) result -= 1;
                return result;
            };
            const animate = ()=>{
                if (!isHovering) return;
                const currentComet1 = comet1Animation.currentTime / 9000;
                const currentComet2 = comet2Animation.currentTime / 19000;
                // Comet 1: Strong attraction (0.15 = fast, eager follower)
                const newComet1 = lerp(currentComet1, targetDistance, 0.15);
                // Comet 2: Weak attraction (0.05 = slow, lazy follower) + trails behind
                const newComet2 = lerp(currentComet2, targetDistance - 0.2, 0.05);
                comet1Animation.currentTime = newComet1 * 9000;
                comet2Animation.currentTime = newComet2 * 19000;
                animationFrameId = requestAnimationFrame(animate);
            };
            cancelAnimationFrame(animationFrameId);
            animationFrameId = requestAnimationFrame(animate);
        };
        const handleMouseEnter = ()=>{
            isHovering = true;
            // Pause animations
            comet1Animation.pause();
            comet2Animation.pause();
        };
        const handleMouseLeave = ()=>{
            isHovering = false;
            cancelAnimationFrame(animationFrameId);
            // Resume animations from current position (wherever mouse left them)
            comet1Animation.play();
            comet2Animation.play();
        };
        svg.addEventListener('mouseenter', handleMouseEnter);
        svg.addEventListener('mouseleave', handleMouseLeave);
        svg.addEventListener('mousemove', handleMouseMove);
        return ()=>{
            svg.removeEventListener('mouseenter', handleMouseEnter);
            svg.removeEventListener('mouseleave', handleMouseLeave);
            svg.removeEventListener('mousemove', handleMouseMove);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);
    return /*#__PURE__*/ _jsxs("svg", {
        ref: svgRef,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 366 300",
        children: [
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsx("style", {
                        children: '\n            :root {\n              --globe-line-color: #B3B3B3;\n              --globe-line-opacity: 0.22;\n            }\n\n            .comet-1 {\n              animation: orbit 9s linear infinite;\n              offset-path: path("M 303 150 A 120 55 -10 0 1 63 150 A 120 55 -10 0 1 303 150 Z");\n            }\n\n            .comet-2 {\n              animation: orbit 19s linear infinite;\n              offset-path: path("M 303 150 A 120 55 -10 0 1 63 150 A 120 55 -10 0 1 303 150 Z");\n            }\n\n            @keyframes orbit {\n              to {\n                offset-distance: 100%;\n              }\n            }\n          '
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        id: "orbit-path",
                        d: "M 303 150 A 120 55 -10 0 1 63 150 A 120 55 -10 0 1 303 150 Z"
                    }),
                    /*#__PURE__*/ _jsxs("mask", {
                        id: "comet-mask",
                        maskUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("rect", {
                                x: "0",
                                y: "0",
                                width: "550",
                                height: "500",
                                fill: "white"
                            }),
                            /*#__PURE__*/ _jsx("path", {
                                d: "M 91 150 A 92 92 0 0 0 275 150 L 91 150 Z",
                                fill: "black"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M 303 150 A 120 55 -10 0 1 63 150",
                stroke: "#7C3AED",
                "stroke-width": "2",
                fill: "none",
                "stroke-linecap": "round"
            }),
            /*#__PURE__*/ _jsx("g", {
                id: "globe",
                children: /*#__PURE__*/ _jsxs("g", {
                    transform: "translate(90.8359, 58)",
                    children: [
                        /*#__PURE__*/ _jsx("circle", {
                            cx: "92.1641",
                            cy: "92",
                            r: "92",
                            fill: "black"
                        }),
                        /*#__PURE__*/ _jsx("circle", {
                            cx: "92.1641",
                            cy: "92",
                            r: "91.1822",
                            stroke: "var(--globe-line-color)",
                            "stroke-opacity": "var(--globe-line-opacity)",
                            "stroke-width": "1.63556"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M92.5383 19.3368C105.94 19.3369 118.168 27.3585 127.081 40.5214C135.992 53.6798 141.529 71.9049 141.529 92.0751C141.528 112.245 135.991 130.47 127.081 143.628C118.168 156.791 105.94 164.812 92.5383 164.812C79.1367 164.812 66.9087 156.791 57.9953 143.628C49.085 130.47 43.5471 112.245 43.5471 92.0751C43.5471 71.9049 49.085 53.6798 57.9953 40.5214C66.9087 27.3585 79.1367 19.3368 92.5383 19.3368Z",
                            stroke: "var(--globe-line-color)",
                            "stroke-opacity": "var(--globe-line-opacity)",
                            "stroke-width": "1.63556"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M92.0156 19.3368C95.1755 19.3368 98.3055 21.1913 101.265 24.8173C104.219 28.437 106.915 33.7242 109.195 40.33C113.753 53.5343 116.588 71.8293 116.588 92.0751C116.588 112.321 113.753 130.615 109.195 143.819C106.915 150.425 104.219 155.713 101.265 159.333C98.3056 162.959 95.1753 164.812 92.0156 164.812C88.8559 164.812 85.7256 162.959 82.7666 159.333C79.8126 155.713 77.1152 150.425 74.835 143.819C70.2772 130.615 67.4434 112.321 67.4434 92.0751C67.4434 71.8293 70.2772 53.5342 74.835 40.33C77.1152 33.724 79.8126 28.437 82.7666 24.8173C85.7257 21.1913 88.8558 19.3368 92.0156 19.3368Z",
                            stroke: "var(--globe-line-color)",
                            "stroke-opacity": "var(--globe-line-opacity)",
                            "stroke-width": "1.63556"
                        }),
                        /*#__PURE__*/ _jsx("circle", {
                            cx: "91.8658",
                            cy: "92",
                            r: "73.1108",
                            stroke: "var(--globe-line-color)",
                            "stroke-opacity": "var(--globe-line-opacity)",
                            "stroke-width": "1.63556"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M92.0154 18.0714L92.0154 165.885",
                            stroke: "var(--globe-line-color)",
                            "stroke-opacity": "var(--globe-line-opacity)",
                            "stroke-width": "1.63556"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M28.5415 55.2597H155.116",
                            stroke: "var(--globe-line-color)",
                            "stroke-opacity": "var(--globe-line-opacity)",
                            "stroke-width": "1.63556"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M18.5349 92L165.048 92",
                            stroke: "var(--globe-line-color)",
                            "stroke-opacity": "var(--globe-line-opacity)",
                            "stroke-width": "1.63556"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M28.691 129.039L154.892 129.039",
                            stroke: "var(--globe-line-color)",
                            "stroke-opacity": "var(--globe-line-opacity)",
                            "stroke-width": "1.63556"
                        }),
                        /*#__PURE__*/ _jsx("circle", {
                            cx: "91.8658",
                            cy: "92",
                            r: "73.1108",
                            stroke: "var(--globe-line-color)",
                            "stroke-opacity": "var(--globe-line-opacity)",
                            "stroke-width": "1.63556"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("g", {
                mask: "url(#comet-mask)",
                children: [
                    /*#__PURE__*/ _jsx("circle", {
                        ref: comet1Ref,
                        r: "9.36856",
                        fill: "#7C3AED",
                        className: "comet-1"
                    }),
                    /*#__PURE__*/ _jsx("circle", {
                        ref: comet2Ref,
                        r: "7.36856",
                        fill: "#7C3AED",
                        className: "comet-2"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M 63 150 A 120 55 -10 0 1 303 150",
                stroke: "#7C3AED",
                "stroke-width": "2",
                fill: "none",
                "stroke-linecap": "round"
            })
        ]
    });
};
